import { FormEvent, useState } from 'react';

import { EventFilters } from '../../../../../services/eventingApi';
import { buttonClass, inputClass } from '../shared/ui';
import { initialFilters, windowError } from './history';

interface EventFiltersFormProps {
  busy: boolean;
  onSearch: (filters: EventFilters) => void;
}

const TEXT_FIELDS: Array<{ key: keyof EventFilters; label: string; placeholder?: string }> = [
  { key: 'eventType', label: 'eventType', placeholder: 'VehicleRegistered.v1' },
  { key: 'aggregateId', label: 'aggregateId' },
  { key: 'eventId', label: 'eventId' },
];

const EventFiltersForm = ({ busy, onSearch }: EventFiltersFormProps) => {
  const [draft, setDraft] = useState<EventFilters>(initialFilters);

  const field = (key: keyof EventFilters) => (change: { target: { value: string } }) =>
    setDraft((current) => ({ ...current, [key]: change.target.value }));

  const error = windowError(draft.from, draft.to);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!error) onSearch({ ...draft });
  };

  return (
    <form className="flex flex-wrap items-end gap-3 text-sm dark:text-gray-200" onSubmit={submit}>
      <label className="flex flex-col gap-1">
        De
        <input type="date" className={inputClass} value={draft.from} onChange={field('from')} required />
      </label>
      <label className="flex flex-col gap-1">
        Até
        <input type="date" className={inputClass} value={draft.to} onChange={field('to')} required />
      </label>
      {TEXT_FIELDS.map(({ key, label, placeholder }) => (
        <label key={key} className="flex flex-col gap-1">
          {label}
          <input className={inputClass} placeholder={placeholder} value={String(draft[key] ?? '')} onChange={field(key)} />
        </label>
      ))}
      <button type="submit" className={buttonClass.secondary} disabled={busy || Boolean(error)}>
        Buscar
      </button>
      {error && <p className="w-full text-xs text-red-600">{error}</p>}
    </form>
  );
};

export default EventFiltersForm;
